import React, { useEffect } from "react";
import styled from "styled-components";
import KeypadView from "../../Model/Individual/KeypadModel/KeypadView";

export default function KeypadForAttendancePage() {
  // Chrome 오버스크롤 시 body 흰 배경 노출 방지 //
  useEffect(() => {
    const prevBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#0A0A0A';
    return () => { document.body.style.backgroundColor = prevBg; };
  }, []);

  // 현재 페이지 내의 채널톡 지우기 //
  useEffect(() => {
    setTimeout(() => {
      document.getElementById('ch-plugin').style.opacity = 0;
      document.getElementById('ch-plugin').style.zIndex = -10;
    }, 100)
  }, [])

  return (
    <TopLevelWrapper>
      <KeypadView/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  min-height: 100svh;

  overflow: hidden;
`;